module.exports = __webpack_public_path__ + "img/as_3a.f5762688.png";